<template>
  <Modal class="max-w-[600px]!">
    <Modal.Title>Privacy controls</Modal.Title>
    <Modal.Body>
      <UpgradeToProCallout v-if="isBasicUser" class="mb-5">
        Privacy options are only available with a Pro Membership
      </UpgradeToProCallout>

      <div :class="classes">
        <div class="flex items-start">
          <LockIcon class="mr-4 size-5 shrink-0 text-gray-800" />
          <div class="flex-1 text-gray-800">
            <div class="text-[16px] leading-[18px]">
              Make registration private
            </div>
            <div class="mt-1 text-[13px] leading-[17px] text-gray-500">
              Only you and people you invite can see the file and description.
            </div>
          </div>
          <Toggle
            v-model="isPrivate"
            :size="isDesktopLayout ? 'md' : 'lg'"
            :disabled="loading"
            class="ml-4 shrink-0"
          />
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="isBasicUser"
        :loading="loading"
        @click="handleSave"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal, Button, Toggle, useModal } from '@dacr/library'
import { LockIcon } from '@dacr/icons'
import { useDevice } from '@/shared/composables/useDevice'
import UpgradeToProCallout from '@/features/billing/components/UpgradeToProCallout.vue'
import type { File } from '@/shared/graphql/router/graphql'
import { useFilePrivacySettings } from './useFilePrivacySettings'

const { close, triggerEvent } = useModal()
const { isDesktopLayout } = useDevice()

const props = defineProps<{
  file: File
}>()

const { isPrivate, isBasicUser, loading, save } = useFilePrivacySettings(
  props.file
)

const classes = computed(() => ({
  'opacity-30 pointer-events-none': isBasicUser.value,
  'mt-4': !isBasicUser.value,
}))

const handleSave = async () => {
  const updated = await save()
  triggerEvent('success', updated)
  close()
}
</script>
